import * as Actions from '@/store/actions/types/analytics';
import { createAction } from '@/store/actions/utils';
export const loadInsights = (insightsType, query) => createAction(Actions.LOAD_INSIGHTS, { insightsType, query });
export const refreshInsights = (insightsType, data) => createAction(Actions.REFRESH_INSIGHTS, { insightsType, data });
export const updateCurrentInsights = (insightsType) => createAction(Actions.UPDATE_CURRENT_INSIGHTS, insightsType);
